import React from 'react'
import Layout from '../layouts/index.js'
import Contact from '../components/contact/contact.js'
import ImageSlider from '../components/hero/index'

function importAll(r) {
  return r.keys().map(r)
}

const images = importAll(
  require.context(
    '../images/pizza-page',
    false,
    /\.(png|jpe?g)$/ // png, jpg, jpeg
  )
)

class LunchTruckPage extends React.Component {
  render() {
    return (
      <Layout head={{ title: 'Pizza Restaurant Box Topper Ads' }}>
        <section id="title">
          <div className="container">
            <div className="row">
              <div className="col text-center">
                <h1 className="heading-title">
                  Pizza Restaurant Box Topper Ads
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section id="pizza-restaurant-box-topper-ads" className="text-center">
          <div className="container">
            <div className="row">
              <div className="col">
                <p className="section-p">Media rate includes:</p>

                <div
                  className="container"
                  style={{ maxWidth: '800px', marginBottom: '20px' }}
                >
                  <div className="row">
                    {/* Card 1 */}
                    <div className="col-md-6 mb-3 d-flex">
                      <div
                        className="d-flex align-items-center p-3 shadow-sm bg-white rounded h-100 w-100"
                        style={{ minHeight: '120px' }}
                      >
                        <div
                          className="bg-dark text-white rounded-circle d-flex justify-content-center align-items-center mr-3"
                          style={{
                            width: '50px',
                            height: '50px',
                            flexShrink: 0,
                            fontWeight: 'bold',
                          }}
                        >
                          1
                        </div>
                        <div className="text-left">
                          30 x 46 Portrait Billboard placed in a visible
                          location on the property
                        </div>
                      </div>
                    </div>

                    {/* Card 2 */}
                    <div className="col-md-6 mb-3 d-flex">
                      <div
                        className="d-flex align-items-center p-3 shadow-sm bg-white rounded h-100 w-100"
                        style={{ minHeight: '120px' }}
                      >
                        <div
                          className="bg-dark text-white rounded-circle d-flex justify-content-center align-items-center mr-3"
                          style={{
                            width: '50px',
                            height: '50px',
                            flexShrink: 0,
                            fontWeight: 'bold',
                          }}
                        >
                          2
                        </div>
                        <div className="text-left">8 x 8 Countertop Ad</div>
                      </div>
                    </div>

                    {/* Card 3 */}
                    <div className="col-md-6 mb-3 d-flex">
                      <div
                        className="d-flex align-items-center p-3 shadow-sm bg-white rounded h-100 w-100"
                        style={{ minHeight: '120px' }}
                      >
                        <div
                          className="bg-dark text-white rounded-circle d-flex justify-content-center align-items-center mr-3"
                          style={{
                            width: '50px',
                            height: '50px',
                            flexShrink: 0,
                            fontWeight: 'bold',
                          }}
                        >
                          3
                        </div>
                        <div className="text-left">
                          4 x 8 Acrylic brochure holder filled with 3.75” W x 8”
                          H double sided brochures for customers inside the
                          restaurant
                        </div>
                      </div>
                    </div>

                    {/* Card 4 */}
                    <div className="col-md-6 mb-3 d-flex">
                      <div
                        className="d-flex align-items-center p-3 shadow-sm bg-white rounded h-100 w-100"
                        style={{ minHeight: '120px' }}
                      >
                        <div
                          className="bg-dark text-white rounded-circle d-flex justify-content-center align-items-center mr-3"
                          style={{
                            width: '50px',
                            height: '50px',
                            flexShrink: 0,
                            fontWeight: 'bold',
                          }}
                        >
                          4
                        </div>
                        <div className="text-left">
                          5,000 of the brochures will be placed on pizza box
                          tops and delivered with to-go orders
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="container" style={{ maxWidth: '1800px' }}>
                  <div className="carousel-container">
                    <ImageSlider images={images} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Contact />
      </Layout>
    )
  }
}
export default LunchTruckPage
